<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->

<div class="main-container"> 
 
    <!-- ============================================================== -->
    <!-- Topbar - style you can find in header.scss -->
    <!-- ============================================================== -->
    <mat-toolbar color="primary" class="topbar telative">
        <!-- ============================================================== -->
        <!-- Logo - style you can find in header.scss -->
        <!-- ============================================================== -->
        <div class="navbar-header">
            <a class="navbar-brand" (click)="show_credits()" >
                <!-- Logo icon --><b>
                    <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
                    <!-- Dark Logo icon -->
                  
                </b>
                <!--End Logo icon -->
                <!-- Logo text -->
                <span fxShow="false" fxShow.gt-xs>
                 <!-- dark Logo text -->
                 <h2 style="color:white">MeeD-PJM</h2>
                
                </span> </a>


        </div>
        <!-- ============================================================== -->
        <!-- sidebar toggle -->
        <!-- ============================================================== -->
        
        <button mat-icon-button (click)="snav.toggle()" value="sidebarclosed">
            <mat-icon [inline]="true">menu</mat-icon>
        </button>

        <!--
       <div class="icon-display med-yellow-icon">
         <mat-icon class="icon-x1-5" [inline]="true">notification_important</mat-icon>
       </div>
       -->
        
          



        <span fxFlex></span>
        <!-- ============================================================== -->
        <!-- app header component - style you can find in header.scss / header.component.ts-->
        <!-- ============================================================== -->
        <app-header></app-header>

        <div class="btn-oficina-mecc" *ngIf="mostrarBotonMecc()" [matMenuTriggerFor]="menuOficinaMecc"></div>
        <mat-menu #menuOficinaMecc="matMenu" yPosition="below" xPosition="before">
            <button mat-menu-item *ngFor="let opcion of opcionesOficinaMecc" (click)="elegirOficinaMecc(opcion)">
                {{ opcion.descripcion }}
            </button>
        </mat-menu>
    </mat-toolbar>
    <!-- ============================================================== -->
    <!-- End Topbar - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->

        <mat-sidenav opened="false" #snav id="snav" class="dark-sidebar pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0" [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches"  >
            
                <app-sidebar></app-sidebar>
               
            
        </mat-sidenav>
        
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
       
         

         
        <mat-sidenav-content class="page-wrapper">
            
                <div  class="page-content">
                   
                        <router-outlet><app-spinner></app-spinner></router-outlet>
                  
                </div>    
               
               
        </mat-sidenav-content>
        
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
    </mat-sidenav-container>
   
</div>
 